import { useEffect, useState } from 'react';

import createLogger from '../../../helpers/logger';

/**
 * Only to be used once in a window, to set the window name
 * In other places please use createLogger("fileName")
 * @param fileName
 * @param windowName
 * @returns Logger
 */
const useLogger = (fileName: string, windowName?: string) => {
  const [logger] = useState(createLogger(fileName));
  useEffect(() => {
    if (windowName) {
      logger.setName(windowName);
    }
  }, []);
  return logger;
};

export default useLogger;
